import Vue from 'vue'
import VueRouter from 'vue-router'
import Error404 from '@/views/Error404.vue'
import MembershipCard from '@/views/MembershipCard.vue'
import MyAccount from '@/views/MyAccount.vue'
import Settings from '@/views/Settings.vue'
import BenefitContainer from '@/views/BenefitContainer.vue'
import Benefit from '@/views/Benefit.vue'
//import EventContainer from '@/views/EventContainer.vue'
//import Event from '@/views/Event.vue'
import NewsContainer from '@/views/NewsContainer.vue'
import News from '@/views/News.vue'
import PageContainer from '@/views/PageContainer.vue'
import Page from '@/views/Page.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: "/",
		name: "membershipCard",
		component: MembershipCard,
		meta: {
			title: "Jäsenkortti",
			icon: "mdi-account-card-details"
		}
	},
	{
		path: "/myaccount",
		name: "myAccount",
		component: MyAccount,
		meta: {
			title: "Omat tiedot",
			headline: "Omat tiedot",
			icon: "mdi-account",
			hidden: true
		}
	},
	{
		path: "/settings",
		name: "settings",
		component: Settings,
		meta: {
			title: "Asetukset",
			headline: "Asetukset",
			icon: "mdi-settings",
			hidden: true
		}
	},
	{
		path: "/benefits",
		name: "benefitContainer",
		component: BenefitContainer,
		meta: {
			title: "Jäsenille",
			icon: "mdi-star"
		},
		children: [
			{
				path: ":pagename",
				name: "benefit",
				component: Benefit,
				props: true,
				meta: {
					title: "Jäsenetu"
				}
			}
		]
	},
/*	{
		path: "/events",
		name: "eventContainer",
		component: EventContainer,
		meta: {
			title: "Tapahtumat",
			icon: "mdi-calendar"
		},
		children: [
			{
				path: ":pagename",
				name: "event",
				component: Event,
				props: true,
				meta: {
					title: "Tapahtuma"
				}
			}
		]
	},*/
	{
		path: "/news",
		name: "newsContainer",
		component: NewsContainer,
		meta: {
			title: "Uutiset",
			icon: "mdi-bullhorn"
		},
		children: [
			{
				path: ":pagename",
				name: "news",
				component: News,
				props: true,
				meta: {
					title: "Uutinen"
				}
			}
		]
	},
	{
		path: "/pages",
		name: "pageContainer",
		component: PageContainer,
		meta: {
			title: "Sivut",
			icon: "mdi-file-document-box-multiple"
		},
		children: [
			{
				path: ":pagename",
				name: "page",
				component: Page,
				props: true,
				meta: {
					title: "Sivu"
				}
			}
		]
	},
	{
		name: "Error404",
		path: "/error404",
		component: Error404,
		meta: {
			title: "Sivua ei löytynyt",
			hidden: true
		}
	},
	{
		path: "*",
		redirect: {
			name: "Error404"
		},
		meta: {
			hidden: true
		}
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// Navigation guards
router.afterEach((to) => {
	// Change meta title
	if (to.meta) {
		document.title = to.meta.title
	} else {
		document.title = to.name
	}
})

export default router
